import { Progress } from "@/components/ui/progress";

export interface TokenUsageProgressProps {
  usagePercentage: number;
  tokensUsed: number;
  monthlyTokens: number;
}

export function TokenUsageProgress({ usagePercentage, tokensUsed, monthlyTokens }: TokenUsageProgressProps) {
  const getProgressColor = (percentage: number) => {
    if (percentage > 90) return "bg-red-500";
    if (percentage > 75) return "bg-amber-500";
    return "bg-emerald-500";
  };

  return (
    <div className="space-y-2">
      <Progress 
        value={usagePercentage} 
        className="h-2 bg-amber-100"
        indicatorClassName={getProgressColor(usagePercentage)}
      />
      <div className="flex justify-between text-sm">
        <span className="text-muted-foreground">
          {tokensUsed.toLocaleString()} tokens brukt
        </span>
        <span className="text-muted-foreground">
          {monthlyTokens.toLocaleString()} totalt
        </span>
      </div>
    </div>
  );
}